import React, {useEffect, useState} from 'react'
import {FORM} from "../i18n/i18n";

const ModalFormTitle = ({
    editMode = false,
    udn = {},
    domainObject = {}
}) => {
    const [title, setTitle] = useState('')

    useEffect(() => {
        const udnTitle = udn?.value ? udn?.value : null
        const domainObjectTitle = domainObject?.title || domainObject?.name || domainObject?.code || null

        let title = ''

        if(udnTitle && domainObjectTitle)
            title = udnTitle + ' / ' + domainObjectTitle
        else if(udnTitle)
            title = udnTitle
        else if(domainObjectTitle)
            title = domainObjectTitle

        setTitle( title)
    }, []);


    if(!editMode)
        return <><i className="far fa-edit mr-2"/>{FORM}</>


    return  <>
        <h2 className={'card-modal-title'}> { title || FORM }</h2>
        <br/>
        <h5 className={'card-modal-uid'}> {'     uid: ' + (domainObject?.uid || '')}</h5>
    </>

}

export default ModalFormTitle